import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UserService } from '../../../../shared/user.service';
import { User } from '../../../../model/user';
import { InternalMsgService } from '../../../../shared/internal.msg.service';
import { SysadminServiceService } from '../../../../shared/sysadmin-service.service';
import { StatusMessagesService } from '../../../../shared/statusmessage.service';
import { BatchJobStatusItem } from '../../../../model/batchjobstatusitem';
import { ReturnObject } from '../../../../model/returnobject';

@Component({
  selector: 'email-batch-job-status',
  templateUrl: 'email-batch-job-status.html',
  styleUrls: ['email-batch-job-status.scss']
})
export class EmailBatchJobStatus implements OnInit {
  @Input() showMe: boolean = false;

  @Output() onCloseDlg: EventEmitter<boolean> = new EventEmitter<boolean>();

  batchJobStatusList: BatchJobStatusItem[] = [];

  loggedUser: User = new User();
  showLoading: boolean = false;

  constructor(
    private userService: UserService,
    private sysadminService: SysadminServiceService,
    private statusMessagesService: StatusMessagesService,
    private msgService: InternalMsgService,
  ) { }

  ngOnInit() {
    this.initServices();
  }

  initServices() {
    this.loggedUser = this.userService.getUser();
    this.getEmailBatchJobStatus();
  }

  getEmailBatchJobStatus() {
      this.showLoading = true;
      this.msgService.ontoggleSpinnerSet(true);
      this.sysadminService.getEmailBatchJobStatus()
          .subscribe((batchJobStatusList: ReturnObject<BatchJobStatusItem[]>) => {
            if (batchJobStatusList.isFailure) {
              this.statusMessagesService.showToasterError('Error', batchJobStatusList.failureMessage);
              return;
            }
            this.batchJobStatusList = batchJobStatusList.value;
            this.showLoading = false;
            this.msgService.ontoggleSpinnerSet(false);
          });
  }

  closeDialog() {
    this.showMe = false;
    this.onCloseDlg.emit(true);
  }

  isSysAdmin(): boolean {
    return this.loggedUser.accessFeatures.includes('sysadmin');
  }
}
